import { render, staticRenderFns } from "./FormIngreso.vue?vue&type=template&id=7aa38524&"
import script from "./FormIngreso.vue?vue&type=script&lang=js&"
export * from "./FormIngreso.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports